<!--
 * @Author: your name
 * @Date: 2022-02-17 10:19:31
 * @LastEditTime: 2022-03-08 10:10:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /supplier-manage/src/views/ forget-password/index.vue
-->
<template>
  <div>
    <page-head head-name="找回密码" />
    <div class="content">
      <el-form
        ref="formLabelAlign"
        :label-position="labelPosition"
        label-width="100px"
        :model="formLabelAlign"
        :rules="rules"
      >
        <el-form-item
          label="手机号:"
          prop="FPhone"
        >
          <el-input
            v-model="formLabelAlign.FPhone"
            placeholder="请填写注册时提供的手机号"
            type="number"
          />
        </el-form-item>
        <div class="item">
          <el-form-item
            label="短信验证码:"
            prop="FCode"
          >
            <el-input
              v-model="formLabelAlign.FCode"
              placeholder="输入验证码"
            />
          </el-form-item>

          <p
            style="
              font-size: 12px;
              font-family: SimSun;
              font-weight: 400;
              color: #3b84d7;
              margin-left: 10px;
              line-height: 60px;
            "
          >
            获取验证码
          </p>
        </div>

        <el-form-item
          label="设置新密码:"
          prop="FPassword"
        >
          <el-input
            v-model="formLabelAlign.FPassword"
            placeholder="请输入新密码"
            autocomplete="off"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码:"
          prop="checkPass"
        >
          <el-input
            v-model="formLabelAlign.checkPass"
            placeholder="请再次输入新密码"
            autocomplete="off"
            type="password"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            class="submitbutton"
            @click="submitForm('formLabelAlign')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { upPassword } from '@/api/user'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formLabelAlign.checkPass !== '') {
          this.$refs.formLabelAlign.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formLabelAlign.FPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      labelPosition: 'left',
      formLabelAlign: {
        FPhone: '',
        FPassword: '',
        FCode: '',
        operationType: '1',
        checkPass: ''
      },
      rules: {
        FPhone: [
          {
            required: true,
            message: '请填写注册时提供的手机号',
            trigger: 'blur'
          },
          { max: 11, message: '长度为11位数字', trigger: 'blur' }
        ],
        FCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        FPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formname) {
      this.$refs.formLabelAlign.validate((valid) => {
        if (valid) {
          // console.log('success submit!!')
          this.getforgetPassword()
        } else {
        //   console.log('error submit!!')
          return false
        }
      })
    },
    async getforgetPassword() {
      const loadingObj = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.submit-test-dialog')
      })
      const fromData = {
        FPhone: this.formLabelAlign.FPhone,
        FPassword: this.formLabelAlign.FPassword,
        FCode: this.formLabelAlign.FCode,
        operationType: '1'
      }
      const res = await upPassword(fromData)
      if (res.code === 200) {
        loadingObj.close()
        this.$message({
          message: res.msg,
          type: 'success'
        })
      } else {
        loadingObj.close()
        this.$message.error('找回密码失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 90%;
  height: 88vh;
  margin: 1px 5% 0 5%;
  background: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 98px;
  // justify-content: center;
  .el-input {
    width: 262px;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .submitbutton {
    width: 220px;
    height: 40px;
    background: #EC212D;
    border-radius: 2px;
    color: #fff;
    border: none;
    margin-top: 200px;
  }
}
</style>
<style >
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  input[type="number"]{
    -moz-appearance: textfield;
  }
</style>
